interface Options {
    dailyId?: string
    permanentId?: string
    sessionId?: string
}

function getAuthHeaders(options?: Options) {
    const headers: Record<string, string> = {}

    if (options == null) {
        return headers
    }

    if (options.sessionId) {
        headers['x-sessionid'] = options.sessionId
    }

    if (options.dailyId) {
        headers['x-dailyid'] = options.dailyId
    }

    if (options.permanentId) {
        headers['x-permanentid'] = options.permanentId
    }

    return headers
}

export default getAuthHeaders
